module.exports = __webpack_public_path__ + "css/img/phone.c6ebe9583f46b1341213b197382d3176.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/_img/phone.svg
// module id = 128
// module chunks = 0